module.exports = __webpack_public_path__ + "img/25.5d303a4d.jpg";